import { cn } from '@nesso/ui/lib/utils';

interface RecordingIndicatorProps {
    className?: string;
    animated?: boolean;
}

export function RecordingCaptureIndicator({
    className,
    animated = true, // added here as feature from dev, can be removed in the future
}: RecordingIndicatorProps) {
    return (
        <span className={cn('relative inline-flex items-center justify-center', className)}>
            <span
                className={cn(
                    'absolute w-2 h-2 bg-secondary-border rounded-full',
                    animated && 'animate-ping [animation-duration:1.5s]',
                )}
            />
            <span className="inline-block w-1 h-1 bg-secondary rounded-full z-20" />
        </span>
    );
}
